"use strict";

import axios from "axios";
import store from "../state/store";
import router from "../router";

const apiUrl = window.__env?.api?.url;

const config = {
    baseURL: apiUrl || process.env.baseURL || process.env.apiUrl || '',
    withCredentials: false, // Bearer-token, nincs cookie-s munkamenet
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
    function (config) {
        if (process.env.VUE_APP_CLIENT_ID) {
            config.headers['X-SPA-ID'] = process.env.VUE_APP_CLIENT_ID;
        }
        config.headers.Accept = 'application/json';
        if (localStorage.getItem('accessToken')) {
            config.headers.Authorization = 'Bearer ' + localStorage.getItem('accessToken');
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

_axios.interceptors.response.use(
    function (response) {
        if (response.data && response.data.token && response.config?.url?.includes('auth/login')) {
            localStorage.setItem('accessToken', response.data.token);
        }
        return response;
    },
    function (error) {
        if (error.response && [401, 419].includes(error.response.status)) {
            const isLoginCall = error.config?.url?.includes('auth/login');

            if (!isLoginCall) {
                store.dispatch('auth/logoutOnlyFrontend');

                if (router.currentRoute?.value?.name !== 'login') {
                    router.push({name: 'login'});
                }
            }
        }

        return Promise.reject(error);
    }
);

export default _axios;
